export var ManagedAgentActionType;
(function (ManagedAgentActionType) {
    ManagedAgentActionType["FLAGGED_STALE"] = "flagged_stale";
    ManagedAgentActionType["SOFT_DELETED"] = "soft_deleted";
    ManagedAgentActionType["FLAGGED_BROKEN"] = "flagged_broken";
    ManagedAgentActionType["FIXED_BROKEN"] = "fixed_broken";
    ManagedAgentActionType["CREATED_CONTENT"] = "created_content";
    ManagedAgentActionType["INSIGHT"] = "insight";
})(ManagedAgentActionType || (ManagedAgentActionType = {}));
export var ManagedAgentTargetType;
(function (ManagedAgentTargetType) {
    ManagedAgentTargetType["CHART"] = "chart";
    ManagedAgentTargetType["DASHBOARD"] = "dashboard";
    ManagedAgentTargetType["SPACE"] = "space";
    ManagedAgentTargetType["PROJECT"] = "project";
})(ManagedAgentTargetType || (ManagedAgentTargetType = {}));
//# sourceMappingURL=managedAgent.js.map